import { MAX_PLAYERS, MIN_PLAYERS } from "../../convex/lib/game";

export function Footer() {
  return (
    <footer className="footer t-micro">
      <span>badlydubbed.games</span>
      <span aria-hidden="true">&middot;</span>
      <span>
        {MIN_PLAYERS}&ndash;{MAX_PLAYERS} players
      </span>
      <span aria-hidden="true">&middot;</span>
      <span>Microphone only. No webcam, ever.</span>
    </footer>
  );
}
